import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';
import * as fromLoginPage from '../reducers/login-page.reducer';
const ɵ0 = (state) => state.loginPage;
export const selectLoginPageState = createSelector(fromFeature.selectAuthState, ɵ0);
export const getLoginPageError = createSelector(selectLoginPageState, fromLoginPage.getError);
export const getLoginPagePending = createSelector(selectLoginPageState, fromLoginPage.getPending);
export { ɵ0 };
